import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { CustomizerComponent } from './customizer/customizer.component';
import { SidebarService } from './sidebar/sidebar.service';

@NgModule({
  exports: [
    CommonModule,
    NavbarComponent,
    SidebarComponent,
    ToggleFullscreenDirective,
    CustomizerComponent,
    NgbModule,
    TranslateModule,
    FormsModule,
  ],
  providers: [
    SidebarService
  ],
  imports:[
    RouterModule,
    CommonModule,
    NgbModule,
    FormsModule,
    TranslateModule
  ],
  declarations: [
    NavbarComponent,
    SidebarComponent,
    CustomizerComponent,
    ToggleFullscreenDirective
  ],
})
export class SharedModule { }
